import React, { useMemo } from 'react'
import { Table } from 'react-bootstrap'
import { formatDiscountPercent, formatMoney, valueOrZero } from '../../helpers/utils'
import ClientHeader from '../../components/ClientHeader/ClientHeader'
import DetailsSummarySection from '../../components/details/summary/DetailsSummarySection'
import TotalsSummaryCard from '../../components/TotalsSummaryCard'
import {
  QUOTE_HEADER_CONFIG,
  buildQuoteCustomFields,
  buildQuoteSummaryFields,
  parseCustomFields
} from '../helpers/quoteHelpers'

const QuoteDetailsTab = ({ quote }) => {
  const hasTaxes2 = Number(quote?.taxes_2 || 0) !== 0

  const parsedDetails = useMemo(
    () =>
      Array.isArray(quote?.details)
        ? quote.details.map((detail) => ({
            ...detail,
            parsedFields: parseCustomFields(detail.custom_fields_item)
          }))
        : [],
    [quote]
  )

  const customFieldKeys = Array.from(
    new Set(parsedDetails.flatMap((detail) => detail.parsedFields.map((field) => field.label)))
  )

  const totalRows = [
    {
      label: 'SUBTOTAL:',
      value: formatMoney(valueOrZero(quote?.subtotal))
    },
    {
      label: 'DESCUENTOS:',
      value: `-${formatMoney(valueOrZero(quote?.discount))}`,
      negative: true
    },
    hasTaxes2 && {
      label: 'IMPUESTOS 2:',
      value: formatMoney(valueOrZero(quote?.taxes_2))
    },
    {
      label: 'IMPUESTOS:',
      value: formatMoney(valueOrZero(quote?.taxes))
    },
    {
      label: 'TOTAL:',
      value: formatMoney(valueOrZero(quote?.total)),
      strong: true,
      dividerBefore: true
    }
  ]

  return (
    <div className="container-fluid px-0">
      <div>
        <div className="show-product-header">
          <h3 className="margin-text-subtitle">Detalles de cotización:</h3>
        </div>
        <hr />
        <ClientHeader data={quote} config={QUOTE_HEADER_CONFIG} />
        <DetailsSummarySection
          summaryFields={buildQuoteSummaryFields(quote)}
          extraFields={buildQuoteCustomFields(quote)}
          summaryTitle="DETALLES DE LA COTIZACIÓN"
          extraTitle="DATOS ADICIONALES"
          summaryOpenLabel="Abrir detalles de la cotización"
          summaryCloseLabel="Cerrar detalles de la cotización"
          extraOpenLabel="Abrir datos adicionales de la cotización"
          extraCloseLabel="Cerrar datos adicionales de la cotización"
        />
        <hr />
        <div className="mr-85 mb-10">
          <b>Productos en cotización:</b>
        </div>
        <Table hover responsive>
          <thead className="table-header-gray-mui">
            <tr>
              <th>CÓDIGO</th>
              <th>NOMBRE DEL PRODUCTO</th>
              <th>UNIDAD DE VENTA</th>
              <th>CANTIDAD</th>
              <th>PRECIO</th>
              <th>% DESCUENTO</th>
              <th>SUB-TOTAL</th>
              {customFieldKeys.map((field) => (
                <th key={field} className="column-custom">
                  {field}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {parsedDetails.length > 0 ? (
              parsedDetails.map((model, index) => (
                <tr key={`${model.product_db_ref}-${index}`}>
                  <td className="order-td-text">{model.product_db_ref || '-'}</td>
                  <td className="order-td-text">{model.product_name || '-'}</td>
                  <td className="order-td-text">{model.package_unit || '-'}</td>
                  <td className="order-td-text">{valueOrZero(model.quantity)}</td>
                  <td className="order-td-money">{formatMoney(valueOrZero(model.price))}</td>
                  <td className="order-td-money">{formatDiscountPercent(model.discount)}</td>
                  <td className="order-td-money">{formatMoney(valueOrZero(model.gross_price))}</td>
                  {customFieldKeys.map((field) => {
                    const fieldData = model.parsedFields.find((item) => item.label === field)
                    return (
                      <td key={field} className="column-custom">
                        {fieldData?.value || '-'}
                      </td>
                    )
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7 + customFieldKeys.length} className="order-td-text">
                  No hay resultados
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <TotalsSummaryCard rows={totalRows} />
      </div>
    </div>
  )
}

export default QuoteDetailsTab
